/* Indulge Erotica: progressive enhancement; never hide content without IntersectionObserver */
(function(){
  if(window.__indulgeEffectsInstalled)return;
  window.__indulgeEffectsInstalled=true;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce||!('IntersectionObserver' in window))return;
  var selectors=['#MainContent .rich-text__blocks','.indulge-moods__heading','.indulge-moods__grid .indulge-mood-card','#MainContent .collection-list .grid__item',
    '#MainContent .product-grid .grid__item','#MainContent .collection .grid__item','#MainContent .multicolumn-list__item',
    '#MainContent .collection-hero__inner','#MainContent .related-products .grid__item',
    '.indulge-mantra__signature','.indulge-mantra__heading-wrap','.indulge-mantra__support','.indulge-contact-hero__copy','.indulge-contact-hero__details','body:has(.indulge-contact-hero) .contact'];
  var observer=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('indulge-reveal-visible');observer.unobserve(entry.target);}});
  },{threshold:.06,rootMargin:'0px 0px -24px 0px'});
  function decorate(){
    var elements=document.querySelectorAll(selectors.join(','));
    Array.prototype.forEach.call(elements,function(el,i){
      if(el.dataset.indulgeObserved==='true')return;
      el.dataset.indulgeObserved='true';
      if(!el.hasAttribute('data-indulge-reveal'))el.setAttribute('data-indulge-reveal','');
      if(!el.style.getPropertyValue('--indulge-stagger'))el.style.setProperty('--indulge-stagger',((i%4)*55)+'ms');
      observer.observe(el);
    });
    document.documentElement.classList.add('indulge-effects-ready');
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',decorate);else decorate();
  document.addEventListener('shopify:section:load',decorate);
  /* Collection filters and lazy-loaded product cards may replace their markup after initial load. */
  var startDynamicObserver=function(){
    var root=document.getElementById('MainContent');
    if(!root || !('MutationObserver' in window))return;
    var queued=false;
    var mo=new MutationObserver(function(records){
      var needsScan=records.some(function(record){return record.addedNodes&&record.addedNodes.length>0;});
      if(needsScan&&!queued){queued=true;requestAnimationFrame(function(){queued=false;decorate();});}
    });
    mo.observe(root,{childList:true,subtree:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',startDynamicObserver);
  else startDynamicObserver();

  /* One-time, accessible typing reveal for the named homepage heading only */
  function indulgeCuriosityTyping(){
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    if(!('IntersectionObserver' in window))return;
    var headings=document.querySelectorAll('#MainContent [id*="190ee44d-dda8-4ef3-be18-5f7f160fd749"] .rich-text__heading');
    Array.prototype.forEach.call(headings,function(heading){
      if(heading.dataset.indulgeTypingInit==='true')return;
      if(heading.textContent.replace(/\s+/g,' ').trim()!=='A little curiosity looks good on you, too.')return;
      heading.dataset.indulgeTypingInit='true';
      var span=heading.querySelector('span');
      if(!span)return;
      var message=span.textContent.trim();
      var started=false;
      var watch=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(!entry.isIntersecting||started)return;
          started=true;watch.disconnect();
          var letters=Array.from(message);
          var height=heading.getBoundingClientRect().height;
          heading.style.minHeight=Math.ceil(height)+'px';
          heading.setAttribute('aria-label',message);
          span.setAttribute('aria-hidden','true');
          span.classList.add('indulge-typing-text','is-typing');
          span.textContent='';
          var textNode=document.createTextNode('');
          span.appendChild(textNode);
          var pos=0;
          var next=function(){
            if(!document.contains(heading))return;
            pos=Math.min(letters.length,pos+1);
            textNode.nodeValue=letters.slice(0,pos).join('');
            if(pos<letters.length){setTimeout(next,42)}
            else{
              setTimeout(function(){span.classList.remove('is-typing');heading.style.minHeight=''},300)
            }
          };
          next();
        });
      },{threshold:.2,rootMargin:'0px 0px -30px 0px'});
      watch.observe(heading);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',indulgeCuriosityTyping);
  else indulgeCuriosityTyping();
  document.addEventListener('shopify:section:load',indulgeCuriosityTyping);

})();
